import AppErrorsAlert from '@molecules/Alerts/AppErrorsAlert'

import { scopedTranslation } from '@utils/I18n'

import FirstNameFieldRow from './FirstNameFieldRow'
import LastNameFieldRow from './LastNameFieldRow'
import EmailFieldRow from './EmailFieldRow'
import MobileFieldRow from './MobileFieldRow'
import CallPhoneFieldRow from './CallPhoneFieldRow'

const t = scopedTranslation('supporter_show')

type ContactDetailsType = {
  supporterId: string | number
  firstName: string | null
  lastName: string | null
  email: string | null
  mobile: string | null
  callPhone: string | null
  canEdit?: boolean
}

export default function ContactDetailsForm({
  supporterId,
  firstName,
  lastName,
  email,
  mobile,
  callPhone,
  canEdit = false,
}: ContactDetailsType) {
  return (
    <>
      <AppErrorsAlert errorsPath="supporterContactDetails" />

      <section
        data-testid="contact-details-form"
        className="tw:flex tw:flex-col tw:px-8 tw:shadow-xs tw:rounded-xl tw:border tw:border-gray-200"
        data-compid="supporter-show_contact-details-form"
      >
        <header className="tw:flex tw:flex-col tw:py-6 tw:border-b tw:border-gray-200">
          <h3 className="tw:font-medium">{t('contact_details')}</h3>
        </header>
        <main className="tw:flex tw:flex-col tw:*:border-b tw:*:border-gray-200">
          <FirstNameFieldRow supporterId={supporterId} firstName={firstName} canEdit={canEdit} />
          <LastNameFieldRow supporterId={supporterId} lastName={lastName} canEdit={canEdit} />
          <EmailFieldRow supporterId={supporterId} initialValue={email} canEdit={canEdit} />
          <MobileFieldRow supporterId={supporterId} initialValue={mobile} canEdit={canEdit} />
          <CallPhoneFieldRow supporterId={supporterId} initialValue={callPhone} canEdit={canEdit} />
        </main>
      </section>
    </>
  )
}
